module.exports = __webpack_public_path__ + "img/bdi.06f36479.svg";